import { jsPDF } from 'jspdf';

const feSaudeLogo = new Image();
feSaudeLogo.src = '../assets/img/fesaude-logo.png';
feSaudeLogo.alt = 'FeSaúde Logo';

const niteroiLogo = new Image();
niteroiLogo.src = '../assets/img/niteroi-logo.jpeg';
niteroiLogo.alt = 'Niterói Logo';

const checked = new Image();
checked.src = '../assets/img/checked.png';
checked.alt = 'checked';

const unchecked = new Image();
unchecked.src = '../assets/img/unchecked.png';
unchecked.alt = 'unchecked';

const pdfFerias = data => { 
  const doc = new jsPDF('p', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  const leftMargin = 15;
  const center = pageWidth / 2;
  let line = 0;
  const step = 15;

  doc.setProperties({
    title: 'FORMULÁRIO DE MARCAÇÃO DE FÉRIAS DO EMPREGADO'
  });

  doc.addImage(niteroiLogo, 'JPEG', 15, 15, 29, 9);
  doc.addImage(feSaudeLogo, 'PNG', pageWidth - 30, 10, 16, 17);
  
  doc.setFontSize(14);
  doc.setFont(undefined, 'bold');
  doc.text(
    'FORMULÁRIO DE MARCAÇÃO DE FÉRIAS DO EMPREGADO',
    center,
    line += (step * 3),
    { align: 'center' }
  );

  doc.text(
    '____________________________________________________',
    center,
    line += 1,
    { align: 'center' }
  );

  doc.setFontSize(12);
  doc.setFont(undefined, 'normal');
  doc.text(
    'À Gerência de Gestão de Pessoas;',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    'Nome: ________________________________________________________________',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  /* doc.text(
    data.nome,
    leftMargin + 15,
    line,
    { align: 'left' }
  ); */

  doc.text(
    'Cargo: ________________________________________________________________',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  /* doc.text(
    data.cargo,
    leftMargin + 15,
    line,
    { align: 'left' }
  ); */

  doc.text(
    'Matrícula: ______________________________________________________________',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  /* doc.text(
    data.matricula,
    leftMargin + 21,
    line,
    { align: 'left' }
  ); */

  doc.text(
    'Lotação: _______________________________________________________________',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  /* doc.text(
    data.lotacao,
    leftMargin + 19,
    line,
    { align: 'left' }
  ); */

  doc.text(
    'Opção pelo abono pecuniário:        SIM        NÃO',
    leftMargin,
    line += step,
    { align: 'left' }
  );

  /* doc.addImage(data.abono === 'SIM' ? checked : unchecked, 'PNG', 75, line - 4, 5, 5);
  doc.addImage(data.abono === 'NÃO' ? checked : unchecked, 'PNG', 92, line - 4, 5, 5); */

  doc.text(
    `Período aquisitivo: _____/_____/_____ a _____/_____/_____`,
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    `Período de gozo de: _____/_____/_____ a _____/_____/_____. Qtd de dias: _____`,
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    `Período de gozo de: _____/_____/_____ a _____/_____/_____. Qtd de dias: _____`,
    leftMargin,
    line += step,
    { align: 'left' }
  );

  doc.text(
    'Assinatura do empregado: ___________________________________________________',
    leftMargin,
    line += step + 5,
    { align: 'left' }
  );

  doc.text(
    '____________________________________________________________\nAutorização da Chefia Imediata (Carimbo e Rubrica)',
    center,
    line += step + 5,
    { align: 'center' }
  );

  doc.text(
    'Data _____/_____/_____',
    leftMargin,
    line += step + 5,
    { align: 'left' }
  );

  doc.setFontSize(8);
  doc.text(
`
Fundação Estatal de Saúde de Niterói – FeSaúde
Endereço: Rua Santa Clara, 102 – Ponta D'Areia – Niterói – RJ – CEP: 24040-050
Telefone: 2714-6579 / CNPJ: 34.906.284/0001-00
`,
    center,
    275,
    { align: 'center' }
  );

  window.open(URL.createObjectURL(doc.output(
    'blob',
    {
      filename: `marcacao-ferias-${data.nome}-${data.matricula}`
    }
  )));
};

export default pdfFerias;
